import React from 'react'

const PageLayout = ({ content }) => {
    return (
        <div className='py-8'> {content} </div>
    )
}

export default PageLayout